import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { AccountEntities } from "../AccountEntities";
import ServiceUserAccessList from "../components/ServiceUserAccessList";

interface ServiceUserViewPageProps extends NSARouterMakerResult, AccountRouterProps
{ }

export default function ServiceUserViewPage(props: ServiceUserViewPageProps)
{
    return (
        <AccountLayout {...props}
            action={{
                title: 'Service User View',
                description: 'Manage the service users connected to your account, including machines and applications.',
                menus: {}
            }}
            pages={{
                entity: AccountEntities.service_user(props),
                view: {
                    ui: {
                        getChildrenAfter: (id, row) => (
                            <ServiceUserAccessList
                                {...props}
                                service_user_id={id}
                                service_user_email={row?.email ?? null}
                            />
                        )
                    }
                }
            }}
        >
            <></>
        </AccountLayout>
    );
};